<template>
  <div>
    <div v-if="!isContainerInited" class="d-flex align-items-center justify-content-center" style="min-height:300px">
      <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">{{$t('messages.loading')}}</span>
        </div>
        {{$t('messages.loading')}}
    </div>
    <div v-if="optional || hasSession" class="container my-3">
      <!-- Pass sessionState and sessionId to slot via scoped slot -->
      <slot :sessionState="sessionState" :sessionId="sessionId" ></slot>
    </div>
    <div v-else class="alert alert-primary my-3" role="alert">
      <i class="bi bi-lock"></i>
      <i18n-t keypath="messages.notsignedin" tag="span" for="messages.signin">
          <a href="#"  onclick="window.dialogManager?.showSignIn(); return false;">{{ $t('messages.signin') }}</a>
      </i18n-t>
    </div>

    <CommonModals />
  </div>
</template>
<script setup>
import { i18Utils } from "@/visualcrossing-core/i18utils";
</script>
<script>
import translations from '@/translations/loadermonitor.js';
import CommonModals from './CommonModals.vue';
export default {
   i18n: {
    messages: translations,
  },
  name: 'LoaderMonitor',
  props: {
   optional:false
  },
data() {
    return {
      isContainerInited:false,
      sessionId:null,
      sessionState:null,
    };
  },
  methods: {
    
  },
  computed: {
    hasSession() {
      return this.sessionId && this.sessionState;
    }
  },
  unmounted() {
    var me=this;

  },
  mounted() {
    var me=this;
    
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.error("No vcCommunicator in LoaderMonitor!");
      return;
    }

    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    me.isContainerInited=vcCommunicator.isInited || me.sessionId;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
      me.isContainerInited=true;
    
    });
    vcCommunicator.addHandler('createsessionfailed', function (sessionId,sessionState) {
      me.sessionId=null;
      me.sessionState=null;

      me.isContainerInited=true;
     
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
     
    });
  }
};
</script>